import React, { Component } from "react";
import styled from "styled-components";

import { Textarea, TextWrapper } from "../ui/ContentEditable";
import Logo from "../ui/Logo";

import { Helmet } from "react-helmet";
import Button from "../ui/Button";

const maxTelegramMessageLength = 4096 - 2;
const secondsLeftInitial = 120;

const extractContent = html => (new DOMParser()).parseFromString(html, "text/html").documentElement.textContent;
function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, 'g'), replace);
}
const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;

  min-height: 100vh;

  @media only screen and (min-width: 62rem) {
    padding-top: 6rem;
  }
`;

const Box = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 0;

  box-shadow: 0 0px 180px 30px #ff0000;
  // box-shadow: 0 0px 150px 80px #ffffff;
  z-index: 100;

  opacity: ${props => (props.opacity ? props.opacity : 0)};
`;

const Container = styled.div`
  @media only screen and (min-width: 62rem) {
    padding-top: 2rem;
  }
`;

const Footer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;

  padding-bottom: 2rem;
`;

const Credits = styled.a`
  // position: absolute;
  // bottom: 1rem;
  // right: 2rem;
  display: inline-block;

  margin-top: 5rem;

  font-size: 0.75rem;
  text-decoration: none;
  color: #777;

  @media only screen and (min-width: 62rem) {
    padding-left: 1.5rem;
  }
`;

const ResetButton = Button.extend`
  // box-sizing: border-box;

  // padding-left: 4rem;
  // padding-right: 4rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  width: 100%;

  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.5rem;
  background-color: #399e6a;
  color: #fff;

  cursor: pointer;
  border-radius: 0.25rem;

  transition: background-color 0.2s;

  :hover {
    background-color: #60be8a;
  }

  @media only screen and (min-width: 62rem) {
    padding-left: 4rem;
    padding-right: 4rem;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;

    width: 60%;

    font-size: 1.5rem;
    line-height: 1.5rem;
  }
`;

const Content = styled.section`
  opacity: ${props => props.opacity};
`;

class WritingBoard extends Component {
  state = {
    html: "",
    secondsLeft: secondsLeftInitial,
    secondsTilEnd: 5.0,
    opacity: 1,
    started: false,
    lost: false,
    won: false
  };

  constructor(props) {
    super(props);

    this.user_id = props.location.pathname.split("/")[1];

    this.fadingSeconds = 2;

    this.sendFinalText = this.sendFinalText.bind(this);
  }

  componentDidMount() {
    // console.log(this.textInput);
    this.textInput.htmlEl.focus();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    clearInterval(this.fadeTimer);
  }

  countSecondsLeft = (secondsLeft: Int) => {
    return Math.max(secondsLeft - 1, 0);
  };

  countSecondsTilEnd = (secondsTilEnd: Int) => {
    return Math.max(secondsTilEnd - 1, 0);
  };

  handleChange = event => {
    if (this.state.won) {
      return false;
    }
    let text = event.target.value;
    if (!this.state.started && text.length > 0) {
      this.startGame();
    }
    this.setState({ html: text, secondsTilEnd: 5, opacity: 1 });

    this.clearFadeTimer();
  };

  startGame = () => {
    this.setState({
      lost: false,
      won: false,
      started: true,
      opacity: 1,
      secondsTilEnd: 5,
      secondsLeft: secondsLeftInitial
    });

    this.timer = setInterval(() => {
      var html = this.state.html;
      var lost = this.state.lost;
      var won = this.state.won;
      let sLeft = this.countSecondsLeft(this.state.secondsLeft);
      let sEnd = this.countSecondsTilEnd(this.state.secondsTilEnd);

      if (sEnd <= this.fadingSeconds) {
        this.clearFadeTimer();

        this.fadeTimer = setInterval(() => {
          this.setState((prevState, prevProps) => ({
            opacity: prevState.opacity - 0.05
          }));
        }, 100);
      }

      if (sEnd <= 0) {
        html = "";
        lost = true;

        clearInterval(this.timer);
        this.clearFadeTimer();
      }

      if (sLeft === 0) {
        won = true;
        if (this.user_id) {
          html = html.slice(0, maxTelegramMessageLength)
          this.sendFinalText(extractContent(replaceAll(html, '<br>', '\n')));
          html = "";
        }

        clearInterval(this.timer);
        this.clearFadeTimer();
      }

      this.setState((prevState, prevProps) => ({
        secondsLeft: sLeft,
        secondsTilEnd: sEnd,
        html: html,
        lost: lost,
        opacity: lost || won ? 1 : prevState.opacity,
        started: !lost && !won,
        won: won
      }));
    }, 1000);
  };

  clearFadeTimer = () => {
    clearInterval(this.fadeTimer);
    this.fadeTimer = null;
  };

  async sendFinalText(text) {
    try {
      let url =
        "http://freewriting.mostcreativecamp.ru/write/" +
        this.user_id +
        "/win";
      let data =  new FormData();
      data.append('message', text);
      let response = await fetch(url, {
        method: "POST",
        body: data
      });
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  }

  onFocus = () => {
    this.textInput.offsetTop = 100;
  };

  render() {
    let secondsLeft = this.state.secondsLeft;
    var opacity = this.state.opacity;

    var lost = this.state.lost;
    var won = this.state.won;
    var placeholder = "Начните писать текст..";

    let reset_btn = null;

    if (lost) {
      placeholder = "Вы проиграли, начните писать заново :(";
    }

    if (won) {
      if (this.user_id) {
        placeholder = "Вы победили, мы отправили текст вам в Телеграм :)";
      } else {
        placeholder = "";
        reset_btn = <div>
          <h3> Вы победили! </h3>
          <ResetButton onClick={() => window.location.reload()}> Еще разок </ResetButton>
        </div>;
      }
    }

    return (
      <Wrapper>
        <Helmet>
          <title>Беглость</title>
        </Helmet>
        <Logo text={secondsLeft} />
        <Box opacity={1 - opacity} />
        <Container className="container">
          <div className="col-xs-9 col-md-9 col-lg-9">
            <Content opacity={opacity}>
              <TextWrapper
                showPlaceholder={this.state.html.length === 0}
                data-placeholder={placeholder}
                placeholderColor={lost || won ? "black" : null}
              >
                <Textarea
                  innerRef={node => (this.textInput = node)}
                  html={this.state.html}
                  disabled={won}
                  onChange={this.handleChange}
                  onFocus={this.onFocus}
                />
              </TextWrapper>
              {reset_btn}
            </Content>
          </div>
        </Container>
        <Footer>
          <div className="container">
            <div className="col-xs-9 col-md-9 col-lg-9">
              <Credits href="https://themostdangerouswritingapp.com/">
                Оригинальный проект
              </Credits>
            </div>
          </div>
        </Footer>
      </Wrapper>
    );
  }
}

export default WritingBoard;



// WEBPACK FOOTER //
// ./src/WritingBoard/index.js